import { useEffect, useState } from 'react';

export const useCanUseOfflineFeature = () => {
  const [canUseOfflineFeature, setCanUseOfflineFeature] = useState(false);

  useEffect(() => {
    const hasCacheStorage = 'caches' in window;
    const hasIndexedDB = 'indexedDB' in window;
    const hasServiceWorker = 'serviceWorker' in navigator;

    const canUse = hasCacheStorage && hasIndexedDB && hasServiceWorker;

    setCanUseOfflineFeature(canUse);
  }, []);

  return canUseOfflineFeature;
};
